import { useQuery } from '@tanstack/react-query'
import { reactQueryRequest } from 'api/makeQuery'
import type { Ticket } from 'components/tickets/types'
import type { PaginatedResponse } from 'types/api'
import { useCallback } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { SortingState } from '@ui-components-3/ui/lib/components/Table/types'
export interface PaginationParams {
  pageIndex: number
  pageSize: number
}

const useMemberTickets = (memberId: string, pagination?: PaginationParams, sorting?: SortingState) => {
  const flags = useFlags()
  const showPhase4Tickets = flags?.tcZendeskTicketsPhase4

  const { data, error, isError, isPending, isSuccess, isFetching, isFetched, refetch } = useQuery({
    queryKey: ['memberTickets', memberId, pagination?.pageIndex, pagination?.pageSize, showPhase4Tickets, sorting],
    queryFn: () => {
      const params: any = { memberId }

      // Re-enable pagination parameters
      if (pagination) {
        params.page = pagination.pageIndex
        params.limit = pagination.pageSize
      }

      params.showPhase4Tickets = showPhase4Tickets

      // Add sort parameters
      if (sorting && sorting.length > 0) {
        params.sort = { [sorting[0].id]: sorting[0].desc ? 'desc' : 'asc' }
      }

      return reactQueryRequest('getMemberTickets', params)
    },
    enabled: !!memberId,
    placeholderData: (previousData) => previousData,
  })

  const refetchMemberTickets = useCallback(() => {
    refetch()
  }, [refetch])

  return {
    memberTickets: data?.paginated || [],
    totalCount: data?.meta?.results || 0,
    error,
    isError,
    isLoading: isPending,
    isSuccess,
    isFetching,
    isFetched,
    refetch: refetchMemberTickets,
  }
}

export default useMemberTickets
